import { api } from './api'
import type { GovernedClientsResponse, ClientPortfolioResponse } from '../types'

export interface GovernedClientsQuery {
  page?: number
  page_size?: number
  search?: string
  is_active?: boolean
  risk_profile?: string
}

export class GovernedClientsService {
  /**
   * Get all governed clients with optional filtering
   */
  static async getGovernedClients(
    query: GovernedClientsQuery = {}
  ): Promise<GovernedClientsResponse> {
    // Build request body instead of query params
    const requestBody: any = {}

    if (query.page) requestBody.page = query.page
    if (query.page_size) requestBody.page_size = query.page_size
    if (query.search) requestBody.search = query.search
    if (query.is_active !== undefined) requestBody.is_active = query.is_active
    if (query.risk_profile) requestBody.risk_profile = query.risk_profile

    const response = await api.post<GovernedClientsResponse>(
      '/governed/clients/',
      requestBody,
      { timeout: 30000 }
    )

    return response.data
  }

  /**
   * Get a single governed client by ID
   */
  static async getGovernedClient(id: number): Promise<GovernedClientsResponse> {
    const response = await api.post<GovernedClientsResponse>(
      `/governed/clients/${id}/`,
      {},
      { timeout: 30000 }
    )
    return response.data
  }

  /**
   * Get detailed client portfolio data by client identifier
   */
  static async getClientPortfolio(clientIdentifier: string): Promise<ClientPortfolioResponse> {
    const response = await api.post<ClientPortfolioResponse>(
      '/governed/client-portfolio/',
      {
        client_identifier: clientIdentifier
      },
      { timeout: 30000 }
    )
    return response.data
  }
}